import { render } from "./AppointmentsView.html?vue&type=template&id=227da7e4&scoped=true&external"
import script from "./AppointmentsView.js?vue&type=script&lang=js&external"
export * from "./AppointmentsView.js?vue&type=script&lang=js&external"

import "./AppointmentsView.css?vue&type=style&index=0&id=227da7e4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227da7e4"]])

export default __exports__